<template>
  <div class="page">
    <div class="ctrl">
      <a-button type="primary" @click="show_create = true">添加公告</a-button>
    </div>
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="options" slot-scope="text, record">
        <router-link target="_blank" :to="'/article/view?id=' + record.id">
          <a-button size="small">查看</a-button>
        </router-link>
        <a-divider type="vertical" />
        <a-popconfirm
          title="确定要移除吗？"
          ok-text="确定"
          cancel-text="取消"
          @confirm="remove(record.rec_id)"
        >
          <a-button type="danger" size="small">移除</a-button>
        </a-popconfirm>
      </template>
    </a-table>

    <CreateModal v-if="show_create" :exh_id="exh_id" @callback="added" />
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
import CreateModal from "./create";
export default {
  components: { CreateModal },
  data() {
    return {
      columns: [
        {
          title: "#",
          dataIndex: "rec_id",
        },
        {
          title: "标题",
          dataIndex: "title",
        },
        {
          title: "操作",
          scopedSlots: {
            customRender: "options",
          },
        },
      ],
      exh_id: null,
      list: [],
      show_create: false,
    };
  },
  async created() {
    this.exh_id = this.$route.query.exh_id;
    this.getList();
  },
  methods: {
    async getList() {
      const r = await this.$axios.get("/notice/getList?exh_id=" + this.exh_id);
      if (r.status == 1) this.list = r.list;
    },
    added(e) {
      this.show_create = false;
      if (e) this.getList();
    },
    async remove(id) {
      const r = await this.$axios.post("/notice/remove", {
        id: id,
      });

      if (r.status == 1) {
        this.getList();
      }
    },
  },
};
</script>

<style>
</style>